function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30 19.153v5.605A4.5 4.5 0 1 0 31.973 29H32V13.377a3 3 0 0 0-3.353-2.98l-10 1.186A3 3 0 0 0 16 14.562v10.196A4.5 4.5 0 1 0 17.973 29H18v-8.133l12-1.714ZM16 28.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0ZM27.5 26a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm2.5-8.867v-3.756a1 1 0 0 0-1.118-.994l-10 1.186a1 1 0 0 0-.882.993v4.285l12-1.714Z",
  fill: "currentColor",
  fillOpacity: 1
});

var SvgAddMusic = function SvgAddMusic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddMusic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-music.2dcfa261.svg";
export { ForwardRef as ReactComponent };